var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{staticClass:"view-inline-icon",attrs:{"asset":_vm.asset,"scale-up":_vm.scaleUp,"adjust":_vm.adjust,"title":_vm.title}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30482f3e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/InlineIcon.vue
// module id = 383
// module chunks = 0